export const contactsTranslations = {
  en: {
    'contacts.title': 'Contacts',
    'contacts.count': '{count} contact',
    'contacts.count_plural': '{count} contacts',
    'contacts.shown': '{count} shown',
    'contacts.groups': 'Groups',
    'contacts.sort': 'Sort: {{sortBy}}',
    'contacts.sortByName': 'Sort by Name',
    'contacts.sortByRecent': 'Sort by Recent',
    'contacts.sortByFrequent': 'Sort by Frequent',
    'contacts.addContact': 'Add Contact',
    'contacts.searchPlaceholder': 'Search contacts by name, email, or phone...',
    'contacts.sampleDataNotice': 'Showing sample contact data - backend connection unavailable',
    'contacts.tabs.all': 'All',
    'contacts.tabs.frequent': 'Frequent',
    'contacts.tabs.recent': 'Recent',
    'contacts.tabs.business': 'Business',
    'contacts.tabs.others': 'Others',
    'contacts.loading': 'Loading contacts...',
    'contacts.error': 'Unable to load contacts. Please try again later.',
    'contacts.emptySearch': 'No contacts match your search',
    'contacts.emptyAll': 'No contacts yet. Add your first contact!',
    'contacts.emptyTab': 'No {{tab}} contacts found',
    'contacts.add.title': 'Add New Contact',
    'contacts.add.name': 'Name',
    'contacts.add.email': 'Email (optional)',
    'contacts.add.phone': 'Phone (optional)',
    'contacts.add.button': 'Add Contact',
    'contacts.add.toast.success': 'Contact added',
    'contacts.add.toast.successDesc': '{{name}} has been added to your contacts.',
    'contacts.add.toast.error': 'Error adding contact',
    'contacts.add.toast.errorDesc': 'Failed to add contact',
    'contacts.profile.sendMoney': 'Send Money',
    'contacts.profile.sendMessage': 'Send Message',
    'contacts.profile.details': 'Contact Details',
    'contacts.profile.totalTransactions': 'Total Transactions',
    'contacts.profile.totalSent': 'Total Sent',
    'contacts.profile.totalReceived': 'Total Received',
    'contacts.profile.lastTransaction': 'Last Transaction',
    'contacts.profile.firstTransaction': 'First Transaction',
    'contacts.profile.delete': 'Delete Contact',
    'contacts.groups.title': 'Contact Groups',
    'contacts.groups.new': 'New Group',
    'contacts.groups.members': '{{count}} member',
    'contacts.groups.members_plural': '{{count}} members',
  },
  es: {
    'contacts.title': 'Contactos',
    'contacts.count': '{count} contacto',
    'contacts.count_plural': '{count} contactos',
    'contacts.shown': '{count} mostrados',
    'contacts.groups': 'Grupos',
    'contacts.sort': 'Ordenar: {{sortBy}}',
    'contacts.sortByName': 'Ordenar por Nombre',
    'contacts.sortByRecent': 'Ordenar por Recientes',
    'contacts.sortByFrequent': 'Ordenar por Frecuentes',
    'contacts.addContact': 'Añadir Contacto',
    'contacts.searchPlaceholder': 'Buscar contactos por nombre, correo electrónico o teléfono...',
    'contacts.sampleDataNotice': 'Mostrando datos de contacto de muestra - conexión con el backend no disponible',
    'contacts.tabs.all': 'Todos',
    'contacts.tabs.frequent': 'Frecuentes',
    'contacts.tabs.recent': 'Recientes',
    'contacts.tabs.business': 'Negocios',
    'contacts.tabs.others': 'Otros',
    'contacts.loading': 'Cargando contactos...',
    'contacts.error': 'No se pueden cargar los contactos. Por favor, inténtalo de nuevo más tarde.',
    'contacts.emptySearch': 'Ningún contacto coincide con tu búsqueda',
    'contacts.emptyAll': 'Aún no hay contactos. ¡Añade tu primer contacto!',
    'contacts.emptyTab': 'No se encontraron contactos {{tab}}',
    'contacts.add.title': 'Añadir Nuevo Contacto',
    'contacts.add.name': 'Nombre',
    'contacts.add.email': 'Correo electrónico (opcional)',
    'contacts.add.phone': 'Teléfono (opcional)',
    'contacts.add.button': 'Añadir Contacto',
    'contacts.add.toast.success': 'Contacto añadido',
    'contacts.add.toast.successDesc': '{{name}} ha sido añadido a tus contactos.',
    'contacts.add.toast.error': 'Error al añadir contacto',
    'contacts.add.toast.errorDesc': 'No se pudo añadir el contacto',
    'contacts.profile.sendMoney': 'Enviar Dinero',
    'contacts.profile.sendMessage': 'Enviar Mensaje',
    'contacts.profile.details': 'Detalles del Contacto',
    'contacts.profile.totalTransactions': 'Transacciones Totales',
    'contacts.profile.totalSent': 'Total Enviado',
    'contacts.profile.totalReceived': 'Total Recibido',
    'contacts.profile.lastTransaction': 'Última Transacción',
    'contacts.profile.firstTransaction': 'Primera Transacción',
    'contacts.profile.delete': 'Eliminar Contacto',
    'contacts.groups.title': 'Grupos de Contactos',
    'contacts.groups.new': 'Nuevo Grupo',
    'contacts.groups.members': '{{count}} miembro',
    'contacts.groups.members_plural': '{{count}} miembros',
  },
  fr: {
    'contacts.title': 'Contacts',
    'contacts.count': '{count} contact',
    'contacts.count_plural': '{count} contacts',
    'contacts.shown': '{count} affichés',
    'contacts.groups': 'Groupes',
    'contacts.sort': 'Trier : {{sortBy}}',
    'contacts.sortByName': 'Trier par nom',
    'contacts.sortByRecent': 'Trier par récent',
    'contacts.sortByFrequent': 'Trier par fréquent',
    'contacts.addContact': 'Ajouter un contact',
    'contacts.searchPlaceholder': 'Rechercher des contacts par nom, e-mail ou téléphone...',
    'contacts.sampleDataNotice': 'Affichage de données de contact d\'exemple - connexion au backend indisponible',
    'contacts.tabs.all': 'Tous',
    'contacts.tabs.frequent': 'Fréquents',
    'contacts.tabs.recent': 'Récents',
    'contacts.tabs.business': 'Entreprise',
    'contacts.tabs.others': 'Autres',
    'contacts.loading': 'Chargement des contacts...',
    'contacts.error': 'Impossible de charger les contacts. Veuillez réessayer plus tard.',
    'contacts.emptySearch': 'Aucun contact ne correspond à votre recherche',
    'contacts.emptyAll': 'Aucun contact pour le moment. Ajoutez votre premier contact !',
    'contacts.emptyTab': 'Aucun contact {{tab}} trouvé',
    'contacts.add.title': 'Ajouter un nouveau contact',
    'contacts.add.name': 'Nom',
    'contacts.add.email': 'E-mail (optionnel)',
    'contacts.add.phone': 'Téléphone (optionnel)',
    'contacts.add.button': 'Ajouter le contact',
    'contacts.add.toast.success': 'Contact ajouté',
    'contacts.add.toast.successDesc': '{{name}} a été ajouté à vos contacts.',
    'contacts.add.toast.error': 'Erreur lors de l\'ajout du contact',
    'contacts.add.toast.errorDesc': 'Échec de l\'ajout du contact',
    'contacts.profile.sendMoney': 'Envoyer de l\'argent',
    'contacts.profile.sendMessage': 'Envoyer un message',
    'contacts.profile.details': 'Détails du contact',
    'contacts.profile.totalTransactions': 'Total des transactions',
    'contacts.profile.totalSent': 'Total envoyé',
    'contacts.profile.totalReceived': 'Total reçu',
    'contacts.profile.lastTransaction': 'Dernière transaction',
    'contacts.profile.firstTransaction': 'Première transaction',
    'contacts.profile.delete': 'Supprimer le contact',
    'contacts.groups.title': 'Groupes de contacts',
    'contacts.groups.new': 'Nouveau groupe',
    'contacts.groups.members': '{{count}} membre',
    'contacts.groups.members_plural': '{{count}} membres',
  },
  sq: {
    'contacts.title': 'Kontaktet',
    'contacts.count': '{count} kontakt',
    'contacts.count_plural': '{count} kontakte',
    'contacts.shown': '{count} të shfaqura',
    'contacts.groups': 'Grupet',
    'contacts.sort': 'Rendit: {{sortBy}}',
    'contacts.sortByName': 'Rendit sipas Emrit',
    'contacts.sortByRecent': 'Rendit sipas të Fundit',
    'contacts.sortByFrequent': 'Rendit sipas të Shpeshtë',
    'contacts.addContact': 'Shto Kontakt',
    'contacts.searchPlaceholder': 'Kërkoni kontakte sipas emrit, email-it ose telefonit...',
    'contacts.sampleDataNotice': 'Duke shfaqur të dhëna kontakti shembull - lidhja me backend nuk është e disponueshme',
    'contacts.tabs.all': 'Të gjitha',
    'contacts.tabs.frequent': 'Të shpeshta',
    'contacts.tabs.recent': 'Të fundit',
    'contacts.tabs.business': 'Biznes',
    'contacts.tabs.others': 'Të tjera',
    'contacts.loading': 'Duke ngarkuar kontaktet...',
    'contacts.error': 'Nuk mund të ngarkohen kontaktet. Ju lutem provoni përsëri më vonë.',
    'contacts.emptySearch': 'Asnjë kontakt nuk përputhet me kërkimin tuaj',
    'contacts.emptyAll': 'Ende nuk ka kontakte. Shtoni kontaktin tuaj të parë!',
    'contacts.emptyTab': 'Nuk u gjetën kontakte {{tab}}',
    'contacts.add.title': 'Shto Kontakt të Ri',
    'contacts.add.name': 'Emri',
    'contacts.add.email': 'Email (opsionale)',
    'contacts.add.phone': 'Telefon (opsionale)',
    'contacts.add.button': 'Shto Kontakt',
    'contacts.add.toast.success': 'Kontakti u shtua',
    'contacts.add.toast.successDesc': '{{name}} është shtuar në kontaktet tuaja.',
    'contacts.add.toast.error': 'Gabim në shtimin e kontaktit',
    'contacts.add.toast.errorDesc': 'Dështoi shtimi i kontaktit',
    'contacts.profile.sendMoney': 'Dërgo Para',
    'contacts.profile.sendMessage': 'Dërgo Mesazh',
    'contacts.profile.details': 'Detajet e Kontaktit',
    'contacts.profile.totalTransactions': 'Transaksionet Totale',
    'contacts.profile.totalSent': 'Totali i Dërguar',
    'contacts.profile.totalReceived': 'Totali i Marrë',
    'contacts.profile.lastTransaction': 'Transaksioni i Fundit',
    'contacts.profile.firstTransaction': 'Transaksioni i Parë',
    'contacts.profile.delete': 'Fshi Kontaktin',
    'contacts.groups.title': 'Grupet e Kontakteve',
    'contacts.groups.new': 'Grup i Ri',
    'contacts.groups.members': '{{count}} anëtar',
    'contacts.groups.members_plural': '{{count}} anëtarë',
  },
  ru: {
    'contacts.title': 'Контакты',
    'contacts.count': '{count} контакт',
    'contacts.count_plural': '{count} контактов',
    'contacts.shown': '{count} показано',
    'contacts.groups': 'Группы',
    'contacts.sort': 'Сортировка: {{sortBy}}',
    'contacts.sortByName': 'Сортировать по имени',
    'contacts.sortByRecent': 'Сортировать по недавним',
    'contacts.sortByFrequent': 'Сортировать по частым',
    'contacts.addContact': 'Добавить контакт',
    'contacts.searchPlaceholder': 'Поиск контактов по имени, email или телефону...',
    'contacts.sampleDataNotice': 'Отображение примерных данных контактов - подключение к backend недоступно',
    'contacts.tabs.all': 'Все',
    'contacts.tabs.frequent': 'Частые',
    'contacts.tabs.recent': 'Недавние',
    'contacts.tabs.business': 'Бизнес',
    'contacts.tabs.others': 'Другие',
    'contacts.loading': 'Загрузка контактов...',
    'contacts.error': 'Не удалось загрузить контакты. Пожалуйста, попробуйте позже.',
    'contacts.emptySearch': 'Нет контактов, соответствующих вашему поиску',
    'contacts.emptyAll': 'Пока нет контактов. Добавьте первый контакт!',
    'contacts.emptyTab': 'Не найдено контактов {{tab}}',
    'contacts.add.title': 'Добавить новый контакт',
    'contacts.add.name': 'Имя',
    'contacts.add.email': 'Email (необязательно)',
    'contacts.add.phone': 'Телефон (необязательно)',
    'contacts.add.button': 'Добавить контакт',
    'contacts.add.toast.success': 'Контакт добавлен',
    'contacts.add.toast.successDesc': '{{name}} добавлен в ваши контакты.',
    'contacts.add.toast.error': 'Ошибка при добавлении контакта',
    'contacts.add.toast.errorDesc': 'Не удалось добавить контакт',
    'contacts.profile.sendMoney': 'Отправить деньги',
    'contacts.profile.sendMessage': 'Отправить сообщение',
    'contacts.profile.details': 'Детали контакта',
    'contacts.profile.totalTransactions': 'Всего транзакций',
    'contacts.profile.totalSent': 'Всего отправлено',
    'contacts.profile.totalReceived': 'Всего получено',
    'contacts.profile.lastTransaction': 'Последняя транзакция',
    'contacts.profile.firstTransaction': 'Первая транзакция',
    'contacts.profile.delete': 'Удалить контакт',
    'contacts.groups.title': 'Группы контактов',
    'contacts.groups.new': 'Новая группа',
    'contacts.groups.members': '{{count}} участник',
    'contacts.groups.members_plural': '{{count}} участников',
  },
  pt: {
    'contacts.title': 'Contatos',
    'contacts.count': '{count} contato',
    'contacts.count_plural': '{count} contatos',
    'contacts.shown': '{count} exibidos',
    'contacts.groups': 'Grupos',
    'contacts.sort': 'Ordenar: {{sortBy}}',
    'contacts.sortByName': 'Ordenar por Nome',
    'contacts.sortByRecent': 'Ordenar por Recentes',
    'contacts.sortByFrequent': 'Ordenar por Frequentes',
    'contacts.addContact': 'Adicionar Contato',
    'contacts.searchPlaceholder': 'Buscar contatos por nome, email ou telefone...',
    'contacts.sampleDataNotice': 'Exibindo dados de contato de exemplo - conexão com backend indisponível',
    'contacts.tabs.all': 'Todos',
    'contacts.tabs.frequent': 'Frequentes',
    'contacts.tabs.recent': 'Recentes',
    'contacts.tabs.business': 'Negócios',
    'contacts.tabs.others': 'Outros',
    'contacts.loading': 'Carregando contatos...',
    'contacts.error': 'Não foi possível carregar contatos. Tente novamente mais tarde.',
    'contacts.emptySearch': 'Nenhum contato corresponde à sua busca',
    'contacts.emptyAll': 'Ainda não há contatos. Adicione seu primeiro contato!',
    'contacts.emptyTab': 'Nenhum contato {{tab}} encontrado',
    'contacts.add.title': 'Adicionar Novo Contato',
    'contacts.add.name': 'Nome',
    'contacts.add.email': 'Email (opcional)',
    'contacts.add.phone': 'Telefone (opcional)',
    'contacts.add.button': 'Adicionar Contato',
    'contacts.add.toast.success': 'Contato adicionado',
    'contacts.add.toast.successDesc': '{{name}} foi adicionado aos seus contatos.',
    'contacts.add.toast.error': 'Erro ao adicionar contato',
    'contacts.add.toast.errorDesc': 'Falha ao adicionar contato',
    'contacts.profile.sendMoney': 'Enviar Dinheiro',
    'contacts.profile.sendMessage': 'Enviar Mensagem',
    'contacts.profile.details': 'Detalhes do Contato',
    'contacts.profile.totalTransactions': 'Total de Transações',
    'contacts.profile.totalSent': 'Total Enviado',
    'contacts.profile.totalReceived': 'Total Recebido',
    'contacts.profile.lastTransaction': 'Última Transação',
    'contacts.profile.firstTransaction': 'Primeira Transação',
    'contacts.profile.delete': 'Excluir Contato',
    'contacts.groups.title': 'Grupos de Contatos',
    'contacts.groups.new': 'Novo Grupo',
    'contacts.groups.members': '{{count}} membro',
    'contacts.groups.members_plural': '{{count}} membros',
  },
  el: {
    'contacts.title': 'Επαφές',
    'contacts.count': '{count} επαφή',
    'contacts.count_plural': '{count} επαφές',
    'contacts.shown': '{count} εμφανίζονται',
    'contacts.groups': 'Ομάδες',
    'contacts.sort': 'Ταξινόμηση: {{sortBy}}',
    'contacts.sortByName': 'Ταξινόμηση κατά Όνομα',
    'contacts.sortByRecent': 'Ταξινόμηση κατά Πρόσφατα',
    'contacts.sortByFrequent': 'Ταξινόμηση κατά Συχνά',
    'contacts.addContact': 'Προσθήκη Επαφής',
    'contacts.searchPlaceholder': 'Αναζήτηση επαφών κατά όνομα, email ή τηλέφωνο...',
    'contacts.sampleDataNotice': 'Εμφάνιση δειγματικών δεδομένων επαφών - σύνδεση με backend μη διαθέσιμη',
    'contacts.tabs.all': 'Όλες',
    'contacts.tabs.frequent': 'Συχνές',
    'contacts.tabs.recent': 'Πρόσφατες',
    'contacts.tabs.business': 'Επαγγελματικές',
    'contacts.tabs.others': 'Άλλες',
    'contacts.loading': 'Φόρτωση επαφών...',
    'contacts.error': 'Δεν ήταν δυνατή η φόρτωση των επαφών. Παρακαλώ δοκιμάστε ξανά αργότερα.',
    'contacts.emptySearch': 'Καμία επαφή δεν ταιριάζει με την αναζήτησή σας',
    'contacts.emptyAll': 'Δεν υπάρχουν ακόμα επαφές. Προσθέστε την πρώτη σας επαφή!',
    'contacts.emptyTab': 'Δεν βρέθηκαν επαφές {{tab}}',
    'contacts.add.title': 'Προσθήκη Νέας Επαφής',
    'contacts.add.name': 'Όνομα',
    'contacts.add.email': 'Email (προαιρετικό)',
    'contacts.add.phone': 'Τηλέφωνο (προαιρετικό)',
    'contacts.add.button': 'Προσθήκη Επαφής',
    'contacts.add.toast.success': 'Η επαφή προστέθηκε',
    'contacts.add.toast.successDesc': 'Η {{name}} προστέθηκε στις επαφές σας.',
    'contacts.add.toast.error': 'Σφάλμα κατά την προσθήκη επαφής',
    'contacts.add.toast.errorDesc': 'Αποτυχία προσθήκης επαφής',
    'contacts.profile.sendMoney': 'Αποστολή Χρημάτων',
    'contacts.profile.sendMessage': 'Αποστολή Μηνύματος',
    'contacts.profile.details': 'Λεπτομέρειες Επαφής',
    'contacts.profile.totalTransactions': 'Συνολικές Συναλλαγές',
    'contacts.profile.totalSent': 'Συνολικά Απεσταλμένα',
    'contacts.profile.totalReceived': 'Συνολικά Ληφθέντα',
    'contacts.profile.lastTransaction': 'Τελευταία Συναλλαγή',
    'contacts.profile.firstTransaction': 'Πρώτη Συναλλαγή',
    'contacts.profile.delete': 'Διαγραφή Επαφής',
    'contacts.groups.title': 'Ομάδες Επαφών',
    'contacts.groups.new': 'Νέα Ομάδα',
    'contacts.groups.members': '{{count}} μέλος',
    'contacts.groups.members_plural': '{{count}} μέλη',
  },
  de: {
    'contacts.title': 'Kontakte',
    'contacts.count': '{count} Kontakt',
    'contacts.count_plural': '{count} Kontakte',
    'contacts.shown': '{count} angezeigt',
    'contacts.groups': 'Gruppen',
    'contacts.sort': 'Sortieren: {{sortBy}}',
    'contacts.sortByName': 'Nach Name sortieren',
    'contacts.sortByRecent': 'Nach neuesten sortieren',
    'contacts.sortByFrequent': 'Nach häufigsten sortieren',
    'contacts.addContact': 'Kontakt hinzufügen',
    'contacts.searchPlaceholder': 'Kontakte nach Name, E-Mail oder Telefon suchen...',
    'contacts.sampleDataNotice': 'Beispiel-Kontaktdaten werden angezeigt - Backend-Verbindung nicht verfügbar',
    'contacts.tabs.all': 'Alle',
    'contacts.tabs.frequent': 'Häufig',
    'contacts.tabs.recent': 'Kürzlich',
    'contacts.tabs.business': 'Geschäftlich',
    'contacts.tabs.others': 'Andere',
    'contacts.loading': 'Kontakte werden geladen...',
    'contacts.error': 'Kontakte konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
    'contacts.emptySearch': 'Keine Kontakte entsprechen Ihrer Suche',
    'contacts.emptyAll': 'Noch keine Kontakte. Fügen Sie Ihren ersten Kontakt hinzu!',
    'contacts.emptyTab': 'Keine {{tab}} Kontakte gefunden',
    'contacts.add.title': 'Neuen Kontakt hinzufügen',
    'contacts.add.name': 'Name',
    'contacts.add.email': 'E-Mail (optional)',
    'contacts.add.phone': 'Telefon (optional)',
    'contacts.add.button': 'Kontakt hinzufügen',
    'contacts.add.toast.success': 'Kontakt hinzugefügt',
    'contacts.add.toast.successDesc': '{{name}} wurde zu Ihren Kontakten hinzugefügt.',
    'contacts.add.toast.error': 'Fehler beim Hinzufügen des Kontakts',
    'contacts.add.toast.errorDesc': 'Kontakt konnte nicht hinzugefügt werden',
    'contacts.profile.sendMoney': 'Geld senden',
    'contacts.profile.sendMessage': 'Nachricht senden',
    'contacts.profile.details': 'Kontaktdetails',
    'contacts.profile.totalTransactions': 'Gesamttransaktionen',
    'contacts.profile.totalSent': 'Gesamt gesendet',
    'contacts.profile.totalReceived': 'Gesamt erhalten',
    'contacts.profile.lastTransaction': 'Letzte Transaktion',
    'contacts.profile.firstTransaction': 'Erste Transaktion',
    'contacts.profile.delete': 'Kontakt löschen',
    'contacts.groups.title': 'Kontaktgruppen',
    'contacts.groups.new': 'Neue Gruppe',
    'contacts.groups.members': '{{count}} Mitglied',
    'contacts.groups.members_plural': '{{count}} Mitglieder',
  },
  ro: {
    'contacts.title': 'Contacte',
    'contacts.count': '{count} contact',
    'contacts.count_plural': '{count} contacte',
    'contacts.shown': '{count} afișate',
    'contacts.groups': 'Grupuri',
    'contacts.sort': 'Sortează: {{sortBy}}',
    'contacts.sortByName': 'Sortează după Nume',
    'contacts.sortByRecent': 'Sortează după Recente',
    'contacts.sortByFrequent': 'Sortează după Frecvente',
    'contacts.addContact': 'Adaugă Contact',
    'contacts.searchPlaceholder': 'Caută contacte după nume, email sau telefon...',
    'contacts.sampleDataNotice': 'Se afișează date de contact de probă - conexiunea la backend indisponibilă',
    'contacts.tabs.all': 'Toate',
    'contacts.tabs.frequent': 'Frecvente',
    'contacts.tabs.recent': 'Recente',
    'contacts.tabs.business': 'Afaceri',
    'contacts.tabs.others': 'Altele',
    'contacts.loading': 'Se încarcă contactele...',
    'contacts.error': 'Nu se pot încărca contactele. Vă rugăm încercați din nou mai târziu.',
    'contacts.emptySearch': 'Niciun contact nu corespunde căutării dvs.',
    'contacts.emptyAll': 'Niciun contact încă. Adăugați primul dvs. contact!',
    'contacts.emptyTab': 'Nu au fost găsite contacte {{tab}}',
    'contacts.add.title': 'Adaugă Contact Nou',
    'contacts.add.name': 'Nume',
    'contacts.add.email': 'Email (opțional)',
    'contacts.add.phone': 'Telefon (opțional)',
    'contacts.add.button': 'Adaugă Contact',
    'contacts.add.toast.success': 'Contact adăugat',
    'contacts.add.toast.successDesc': '{{name}} a fost adăugat la contactele dvs.',
    'contacts.add.toast.error': 'Eroare la adăugarea contactului',
    'contacts.add.toast.errorDesc': 'Nu s-a putut adăuga contactul',
    'contacts.profile.sendMoney': 'Trimite Bani',
    'contacts.profile.sendMessage': 'Trimite Mesaj',
    'contacts.profile.details': 'Detalii Contact',
    'contacts.profile.totalTransactions': 'Total Tranzacții',
    'contacts.profile.totalSent': 'Total Trimis',
    'contacts.profile.totalReceived': 'Total Primit',
    'contacts.profile.lastTransaction': 'Ultima Tranzacție',
    'contacts.profile.firstTransaction': 'Prima Tranzacție',
    'contacts.profile.delete': 'Șterge Contact',
    'contacts.groups.title': 'Grupuri de Contacte',
    'contacts.groups.new': 'Grup Nou',
    'contacts.groups.members': '{{count}} membru',
    'contacts.groups.members_plural': '{{count}} membri',
  },
  sr: {
    'contacts.title': 'Контакти',
    'contacts.count': '{{count}} контакт',
    'contacts.count_plural': '{{count}} контаката',
    'contacts.shown': '{{count}} приказано',
    'contacts.groups': 'Групе',
    'contacts.sort': 'Сортирај: {{sortBy}}',
    'contacts.sortByName': 'Сортирај по имену',
    'contacts.sortByRecent': 'Сортирај по недавним',
    'contacts.sortByFrequent': 'Сортирај по честим',
    'contacts.addContact': 'Додај контакт',
    'contacts.searchPlaceholder': 'Претражите контакте по имену, имејлу или телефону...',
    'contacts.sampleDataNotice': 'Приказују се пробни подаци о контактима - веза са позадином није доступна',
    'contacts.tabs.all': 'Све',
    'contacts.tabs.frequent': 'Чести',
    'contacts.tabs.recent': 'Недавни',
    'contacts.tabs.business': 'Посао',
    'contacts.tabs.others': 'Остали',
    'contacts.loading': 'Учитавање контаката...',
    'contacts.error': 'Није могуће учитати контакте. Покушајте поново касније.',
    'contacts.emptySearch': 'Ниједан контакт не одговара вашој претрази',
    'contacts.emptyAll': 'Још нема контаката. Додајте свој први контакт!',
    'contacts.emptyTab': 'Нису пронађени {{tab}} контакти',
    'contacts.add.title': 'Додај нови контакт',
    'contacts.add.name': 'Име',
    'contacts.add.email': 'Имејл (опционо)',
    'contacts.add.phone': 'Телефон (опционо)',
    'contacts.add.button': 'Додај контакт',
    'contacts.add.toast.success': 'Контакт додат',
    'contacts.add.toast.successDesc': '{{name}} је додат у ваше контакте.',
    'contacts.add.toast.error': 'Грешка при додавању контакта',
    'contacts.add.toast.errorDesc': 'Додавање контакта није успело',
    'contacts.profile.sendMoney': 'Пошаљи новац',
    'contacts.profile.sendMessage': 'Пошаљи поруку',
    'contacts.profile.details': 'Детаљи контакта',
    'contacts.profile.totalTransactions': 'Укупне трансакције',
    'contacts.profile.totalSent': 'Укупно послато',
    'contacts.profile.totalReceived': 'Укупно примљено',
    'contacts.profile.lastTransaction': 'Последња трансакција',
    'contacts.profile.firstTransaction': 'Прва трансакција',
    'contacts.profile.delete': 'Обриши контакт',
    'contacts.groups.title': 'Групе контаката',
    'contacts.groups.new': 'Нова група',
    'contacts.groups.members': '{{count}} члан',
    'contacts.groups.members_plural': '{{count}} чланова',
  },
  pl: {
    'contacts.title': 'Kontakty',
    'contacts.count': '{count} kontakt',
    'contacts.count_plural': '{count} kontaktów',
    'contacts.shown': '{count} wyświetlonych',
    'contacts.groups': 'Grupy',
    'contacts.sort': 'Sortuj: {{sortBy}}',
    'contacts.sortByName': 'Sortuj według Nazwy',
    'contacts.sortByRecent': 'Sortuj według Ostatnich',
    'contacts.sortByFrequent': 'Sortuj według Częstych',
    'contacts.addContact': 'Dodaj Kontakt',
    'contacts.searchPlaceholder': 'Szukaj kontaktów po imieniu, emailu lub telefonie...',
    'contacts.sampleDataNotice': 'Wyświetlanie przykładowych danych kontaktowych - połączenie z backendem niedostępne',
    'contacts.tabs.all': 'Wszystkie',
    'contacts.tabs.frequent': 'Częste',
    'contacts.tabs.recent': 'Ostatnie',
    'contacts.tabs.business': 'Biznesowe',
    'contacts.tabs.others': 'Inne',
    'contacts.loading': 'Ładowanie kontaktów...',
    'contacts.error': 'Nie można załadować kontaktów. Proszę spróbować ponownie później.',
    'contacts.emptySearch': 'Żadne kontakty nie pasują do Twojego wyszukiwania',
    'contacts.emptyAll': 'Brak kontaktów. Dodaj swój pierwszy kontakt!',
    'contacts.emptyTab': 'Nie znaleziono kontaktów {{tab}}',
    'contacts.add.title': 'Dodaj Nowy Kontakt',
    'contacts.add.name': 'Imię',
    'contacts.add.email': 'Email (opcjonalnie)',
    'contacts.add.phone': 'Telefon (opcjonalnie)',
    'contacts.add.button': 'Dodaj Kontakt',
    'contacts.add.toast.success': 'Kontakt dodany',
    'contacts.add.toast.successDesc': '{{name}} został dodany do Twoich kontaktów.',
    'contacts.add.toast.error': 'Błąd podczas dodawania kontaktu',
    'contacts.add.toast.errorDesc': 'Nie udało się dodać kontaktu',
    'contacts.profile.sendMoney': 'Wyślij Pieniądze',
    'contacts.profile.sendMessage': 'Wyślij Wiadomość',
    'contacts.profile.details': 'Szczegóły Kontaktu',
    'contacts.profile.totalTransactions': 'Wszystkie Transakcje',
    'contacts.profile.totalSent': 'Wszystko Wysłane',
    'contacts.profile.totalReceived': 'Wszystko Otrzymane',
    'contacts.profile.lastTransaction': 'Ostatnia Transakcja',
    'contacts.profile.firstTransaction': 'Pierwsza Transakcja',
    'contacts.profile.delete': 'Usuń Kontakt',
    'contacts.groups.title': 'Grupy Kontaktów',
    'contacts.groups.new': 'Nowa Grupa',
    'contacts.groups.members': '{{count}} członek',
    'contacts.groups.members_plural': '{{count}} członków',
  },
};
